import React from "react";
import styles from "./PrivacyPolicyPage.module.scss";

import Footer from '../../components/Footer/Footer';

const PrivacyPolicyPage_It = () => {
  return (
    <>
        <div className={styles.container}>
            <div className={styles.content}>
                <h1>Informativa sulla privacy</h1>
                <hr />
                <p>
                    Attribuiamo grande importanza alla protezione dei tuoi dati personali. 
                    Questa informativa sulla privacy spiega come raccogliamo, utilizziamo e proteggiamo le tue informazioni.
                </p>

                <h2>1. Dati raccolti</h2>
                <p>Raccogliamo i seguenti dati:</p>
                <ul>
                    <li>Nome utente (può essere visualizzato da altri utenti nella classifica generale del gioco)</li>
                    <li>Indirizzo email</li>
                    <li>CAP (utilizzato esclusivamente a fini statistici)</li>
                </ul>

                <h2>2. Base legale per il trattamento</h2>
                <p>
                    Il trattamento dei tuoi dati personali si basa sulle seguenti basi legali:
                </p>
                <ul>
                    <li>Esecuzione del contratto quando utilizzi il nostro servizio.</li>
                    <li>Interesse legittimo per la visualizzazione della classifica generale dei giocatori.</li>
                </ul>

                <h2>3. Periodo di conservazione dei dati</h2>
                <p>
                    I tuoi dati personali vengono conservati per un periodo di <strong>3 anni</strong>&nbsp;
                    dopo la tua ultima attività sul nostro servizio. <br/>Trascorso questo periodo, verranno eliminati.
                </p>

                <h2>4. Utilizzo dei dati</h2>
                <p>Utilizziamo i tuoi dati esclusivamente per:</p>
                <ul>
                    <li>Garantire il corretto funzionamento del servizio</li>
                    <li>Consentirti di effettuare l'accesso</li>
                    <li>Creare statistiche di gioco e una classifica generale dei giocatori (visualizzazione solo del nome utente)</li>
                    <li>Analizzare la distribuzione geografica dei giocatori (tramite CAP, in modo anonimo)</li>
                </ul>

                <h2>5. Protezione dei tuoi dati</h2>
                <p>
                    Implementiamo misure tecniche e organizzative adeguate per 
                    proteggere le tue informazioni da accessi non autorizzati, alterazioni, divulgazioni o distruzioni.
                    Queste misure includono la crittografia dei dati e controlli di accesso rigorosi.
                </p>

                <h2>6. I tuoi diritti</h2>
                <p>
                    In conformità con il GDPR, hai i seguenti diritti:
                </p>
                <ul>
                    <li>Diritto di accesso: puoi ottenere una copia dei tuoi dati.</li>
                    <li>Diritto di rettifica: puoi correggere le tue informazioni.</li>
                    <li>Diritto alla cancellazione: puoi richiedere l'eliminazione dei tuoi dati.</li>
                    <li>Diritto alla portabilità dei dati: puoi ricevere i tuoi dati in un formato strutturato.</li>
                    <li>Diritto alla limitazione del trattamento: in determinate condizioni, puoi richiedere la limitazione dell'uso dei tuoi dati.</li>
                </ul>
                <p>
                    Per esercitare questi diritti, contattaci al seguente indirizzo:&nbsp;
                    <a className={styles.link} href="mailto:contact@hatanna-editions.fr">contact@hatanna-editions.fr</a>.
                </p>

                <h2>7. Reclamo alla CNIL</h2>
                <p>
                    Se ritieni che i tuoi diritti non vengano rispettati, puoi presentare un reclamo 
                    alla CNIL (Commission Nationale de l'Informatique et des Libertés) sul loro sito ufficiale:
                    <a className={styles.link} href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer"> www.cnil.fr</a>.
                </p>

                <h2>8. Trasferimento dei dati al di fuori dell'UE</h2>
                <p>
                    I tuoi dati vengono archiviati all'interno dell'Unione Europea. Non viene effettuato alcun trasferimento al di fuori dell'UE. I tuoi dati non vengono condivisi con terze parti.
                </p>
            </div>
        </div>

        <Footer/>
    </>
  );
};

export default PrivacyPolicyPage_It;
